import { AddShippingAddress as AddShippingAddressShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/AddShippingAddress';
import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';

export const AddShippingAddress = () => {
  const { refreshAddresses } = usePreAuthDrawCtx();
  const { goToStep } = useFlow();
  return (
    <AddShippingAddressShared
      onAddressUpdate={async (addressId) => {
        await refreshAddresses(addressId);
        goToStep('apply');
      }}
    />
  );
};
